"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const helper_1 = require("components/cosmos/tooltip/helper");
const DeleteModal_1 = __importDefault(require("components/modal/DeleteModal"));
const translate_1 = require("components/translate");
const useModal_1 = require("hooks/useModal");
const mobx_react_1 = require("mobx-react");
const class_1 = require("modules/app/services/datahub/class");
const ClassService_1 = __importDefault(require("modules/classManager/ClassService"));
const deleteClassButton_module_scss_1 = __importDefault(require("./deleteClassButton.module.scss"));
const DeleteClassButton = ({ t, classId, isMobile, totalUsersMap, onDelete }) => {
    const { isModalOpen, handleClose, handleOpen } = (0, useModal_1.useModal)();
    const totalUsers = totalUsersMap.get(classId);
    const hasUsers = Boolean(totalUsers && totalUsers > 0);
    const handleConfirm = async () => {
        await ClassService_1.default.delete(classId, onDelete);
        class_1.DatahubClassService.sendDeleteClassEvent({
            category: class_1.ClassCategory.ConfirmDeleteClass,
            classId
        });
    };
    const classes = (0, classnames_1.default)('_text-red _border-0', {
        [deleteClassButton_module_scss_1.default.button]: hasUsers
    });
    const handleCancel = () => {
        handleClose();
        class_1.DatahubClassService.sendDeleteClassEvent({
            category: class_1.ClassCategory.CancelDeleteClass,
            classId
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _align-items-center _justify-content-end", children: [(0, jsx_runtime_1.jsxs)("button", { className: classes, disabled: hasUsers, onClick: handleOpen, children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'trash'], className: "_mr-2" }), (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.delete_class_01" })] }), hasUsers && ((0, jsx_runtime_1.jsx)(tooltip_1.default, { content: t('class_manager.class_editor.delete_class_tooltip', {
                    checkOnlineEvent: true
                }), position: (0, helper_1.setPosition)(tooltip_1.default.TOOLTIP_POSITION.LEFT, tooltip_1.default.TOOLTIP_POSITION.LEFT, isMobile), className: "_ml-2 _pr-1", children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'question-circle'] }) })), isModalOpen && ((0, jsx_runtime_1.jsx)(DeleteModal_1.default, { isOpen: true, title: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_list.delete_content_title" }), description: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "general.delete_content_module_description" }), confirmLabel: "general.delete_content_module_confirm", onCancel: handleCancel, onConfirm: handleConfirm }))] }));
};
exports.default = (0, mobx_react_1.inject)((store) => ({
    isMobile: store.UiStore.isMobile,
    totalUsersMap: store.ClassStore.totalUsersMap
}))((0, translate_1.translate)()(DeleteClassButton));
